"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var parentStyle = {
  height: '100%',
  width: '100%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(18, 21, 25, 0.65), #000000 108%)'
};
var iconStyle = {
  height: '100%',
  width: '100%',
  maxWidth: '36px',
  maxHeight: '36px',
  fill: '#898989'
};

var LockIcon = function LockIcon() {
  return _react.default.createElement("div", {
    style: parentStyle
  }, _react.default.createElement(_Icon.default, {
    type: "lock",
    iconColor: "#009fd8",
    style: iconStyle
  }));
};

var _default = LockIcon;
exports.default = _default;